import { cloud, three, data, rt } from "xx-packages";

import { WebGLRenderer, REVISION } from "three";
import device from "./Device";
import { preloadFont } from "troika-three-text";
import "./index.css";

import "./code/comp.js";
import "./code/ctrl.js";

/* globals preloader */

const { cloudClient, typeManager } = cloud;
const { AppSingle, modelLoader } = three;
const { queryStringToObject } = data.conversion;

const { extAssetCache } = three;
const { ProxyUpdaters } = rt;

const preloader = window.preloader;

// REGISTER LOADERS

const params = queryStringToObject(window.location.search);

/* DEFAULT CONSTANTS - OBSOLATE ******************************************/

const inputManConf = {
  mkb: {
    enabled: true,
    channels: {
      ui: {
        enabled: false,
        count: 2,
      },
    },
  },
  touch: {
    enabled: false,
  },
  gamepad: {
    enabled: false,
  },
  midi: {
    enabled: !!params.forwardMIDI,
  },
  network: {
    enabled: false,
    p2pBrokerUrl: "wss://vjycloud.herokuapp.com/p2p/",
    peerId: params.peerId,
    connection: {
      peerId: params.remotePeerId,
      retryIntervalSeconds: 10,
      maxRetries: 5,
      forwardMIDI: params.forwardMIDI,
    },
  },
};

const appDecl = {
  settings: {
    cloud: {
      //includeMeta: false
      loadThumbnails: false,
    },

    inputMan: inputManConf,

    audioMan: {
      musicMeta: {},
    },
  },

  ui: {
    main: null,
    sys: {
      enabled: true,
      visible: false,
    },
  },

  project: {
    doAddHTML: true,
    doAddCSS: true,
    doScroll: false,
    allowSceneHTML: true,
    override: {},
    n: "Acuario",
  },
  dominantContext: "composition",
};

const uiExp = {
  t: "UIExp",
  d: {
    infoBox: {
      enabled: true,
    },
    paramStack: {
      enabled: true,
      elems: [{ t: "effect" }, { t: "color" }],
    },
  },
};

// window._params = {
// 	compOverrideSettings: {
// 		rot0: 0,
// 		rotSection: 0,
// 		y0: -0.18
// 	}
// }
console.log("BUILDINFO");

window._params = {
  // compId: "67dafd5ec90696f23e37c7dc",
  project: "DentsuExport",
  doAddCSS: true,
  doAddHTML: true,
};
if (window?._params?.compId) {
  params.compId = window._params.compId;
}
if (window?._params?.project && window?._params?.project?.length) {
  params.project = window._params.project;
}
if (window?._params?.compOverrideSettings) {
  params.compOverrideSettings = window._params.compOverrideSettings;
  appDecl.compOverrideSettings = window._params.compOverrideSettings;
}
if (window?._params?.doAddHTML !== undefined) {
  appDecl.project.doAddHTML = window?._params?.doAddHTML;
}
if (window?._params?.doAddCSS !== undefined) {
  appDecl.project.doAddCSS = window?._params?.doAddCSS;
}
if (window?._params?.doScroll !== undefined) {
  appDecl.project.doScroll = window?._params?.doScroll;
}

if (!document.getElementById("canvas")) {
  const canvas = document.createElement("canvas");
  canvas.id = "canvas";
  document.body.insertBefore(canvas, document.querySelector("#content"));
}

async function startApp() {
  let config = window._config;
  await new Promise((resolve) => {
    preloadFont(
      {
        font: "https://dwohp4umqrwym.cloudfront.net/clients/dentsu/halcom.woff",
      },
      () => {
        resolve();
        // myApp.showScene()
      }
    );
  });

  console.log("ENV ", process.env.NODE_ENV);

  if (process.env.NODE_ENV === "production") {
    // if (false || process.env.NODE_ENV === "production") {
    // build step
    let cloudBaseUrl = "./";

    if (window?._params?.cloudBaseUrl)
      cloudBaseUrl = window?._params?.cloudBaseUrl;

    let cloudInitSettings = {
      apiBaseUrl: "", //config.cloud.apiBaseUrl,
      storage: window.localStorage,
      settings: appDecl.settings.cloud,
      cloudBaseUrl,
    };

    // if we have a window config, honour it
    // eg for cases where we synced different projects in different folders,
    // but we use the same web app for all of them
    if (config) {
      cloudInitSettings = {
        apiBaseUrl: config.cloud.apiBaseUrl,
        storage: window.localStorage,
        settings: appDecl.settings.cloud,
        cloudName: config.cloud.cloudName,
        cloudBaseUrl,
      };
    }

    await cloudClient.init(cloudInitSettings);

    if (window?._params?.doAddHTML === undefined)
      appDecl.project.doAddHTML = false;
    if (window?._params?.doAddCSS === undefined)
      appDecl.project.doAddCSS = false;
    if (window?._params?.doScroll === undefined)
      appDecl.project.doScroll = true;
  } else {
    if (!config) {
      try {
        const res = await fetch(process.env.PUBLIC_URL + "/config.json");
        config = await res.json();
      } catch (err) {
        console.warn(
          "Error fetching config at: " +
            process.env.PUBLIC_URL +
            "/config.json",
          err
        );
      }
      const e = new CustomEvent("xrc:preloader-log", {
        detail: { msg: "Loaded config.json", type: "startEvent" },
      });
      window.dispatchEvent(e);
    }

    if (!config) throw new Error("No config found");

    await cloudClient.init({
      apiBaseUrl: config.cloud.apiBaseUrl,
      storage: window.localStorage,
      settings: appDecl.settings.cloud,
      cloudName: config.cloud.cloudName,
      // cloudBaseUrl: '/',
    });
    const evv = new CustomEvent("xrc:preloader-log", {
      detail: { msg: "Init Cloud Client", type: "startEvent" },
    });
    window.dispatchEvent(evv);
  }

  // const res = await cloudClient.find(
  //   "5e3493525a2b0f0017d2fbce",
  //   // "5b546e3467bc7f001405ce84",

  //   {
  //     deps: true,
  //   },
  //   {
  //     cacheResults: true,
  //     cacheTypeDefs: true,
  //   }
  // );
  // console.log("RES", res);
  // return;

  const user = await cloudClient.getCurrentUser();
  const ev = new CustomEvent("xrc:preloader-log", {
    detail: { msg: "Loading user info", type: "startEvent" },
  });
  window.dispatchEvent(ev);

  if (!device.hasWebGL) {
    return preloader.showUnsupportedMessage();
  }

  if (params.assetId) {
    appDecl.asset = { ">link": { id: params.assetId } };
    appDecl.project.override = {
      scene: {
        startComp: { ">link": { id: params.assetId } },
      },
    };
  } else if (params.compId) {
    appDecl.asset = { ">link": { id: params.compId } };
    appDecl.project.override = {
      scene: {
        startComp: { ">link": { id: params.compId } },
      },
    };
  }

  if (params.project) {
    if (params.project == "View.AV") {
      appDecl.project.id = user.settings.viewAV[">link"].id;
    } else {
      appDecl.project.n = params.project;
    }
  } else appDecl.project.id = user.settings.view[">link"].id;

  const app = new AppSingle(appDecl);
  // app.preloader = preloader;
  app.device = device;
  app.enableScreenshot = true;
  app.scene.enableScreenshot = true;

  // when in an iframe, app needs to know this
  // that way it won't create graph
  if (window.parent) app.isIframePreview = true;

  await app.start();
  // app.start();

  console.log("View AppDecl >", appDecl);

  window.app = app;

  if (!window.parent || window.location == window.parent.location) return;

  let proxyUpdater;
  let hasError = false;

  // monitor.initUI()
}

startApp();
